import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetProjectSummaryQuery } from "../../../services/Reports";
import {
  getProjectSummaryRequest,
  getProjectSummaryFailure,
  getProjectSummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allProjectSummary,
    isLoading: projectSummaryLoading,
    isError: projectSummaryError,
  } = useGetProjectSummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.projectSummaryPageNo,
    pageSize: state.projectSummaryPageSize,
    fromDate: new Date(state.projectSummaryFromDate).toLocaleDateString(),
    toDate: new Date(state.projectSummaryToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (projectSummaryLoading) {
      dispatch(getProjectSummaryRequest());
    }
    if (projectSummaryError) {
      dispatch(getProjectSummaryFailure(projectSummaryError));
    }
    if (allProjectSummary) {
      dispatch(
        getProjectSummarySuccess({
          data: allProjectSummary.data.projectSummary[0].data || [],
          totalPages:
            allProjectSummary.data.projectSummary[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allProjectSummary,
    profileData,
    state.projectSummaryFromDate,
    state.projectSummaryToDate,
    state.projectSummaryPageNo,
    state.projectSummaryPageSize,
  ]);
  return <></>;
};
export default Content;
